import type { HttpErrorResponse } from '@angular/common/http';
import type { EntityState } from '@ngrx/entity';
import { GetAnnualReportTemplateTranslation } from '../dtos/get-annual-report-template-translation.dto';
import { IAnnualReportTemplateDTO } from './annual-report-template-dto.interface';

export interface IAnnualReportTemplateFeatureState extends EntityState<IAnnualReportTemplateDTO> {
    activeArTemplate: IAnnualReportTemplateDTO | undefined;
    activeBalanceSheetTaxonomy: string | undefined;
    activeIncomeStatementTaxonomy: string | undefined;
    activeNotesTemplate: string | undefined;
    activePdfTemplate: string | undefined;
    error: HttpErrorResponse | undefined;
    locales: string[] | undefined;
    translations: GetAnnualReportTemplateTranslation[] | undefined;
}
